<app-pdf-page>
  <app-pdf-page-header [logoSize]="logoSize.LARGE" [repeat]="false" [spacer]="false"></app-pdf-page-header>
  <div class="pdf-page__project-image">
    @if (!isEmpty(projectDetails.projectInfo.imageBase64)) {
      <img [src]="projectDetails.projectInfo.imageBase64">
    }
    <div class="pdf-page__project-intro">
        <h1 class="pdf-page__project-title"><span>{{ projectDetails.name }}</span> <span
            class="pdf-page__version">{{ getProjectVersion() }}</span></h1>
      @if (projectDetails.description && projectDetails.description !== '') {
        <div class="pdf-page__project-description">{{ projectDetails.description }}</div>
      }
    </div>
  </div>
  <div class="grid-spacer"></div>
  <div class="grid">
    <div class="grid__row">
      <div class="grid__col grid__col--7">
        <table class="table-info prevent-pagebreak-inside">
          <tbody>
            <tr>
              <th>{{ 'PAGE_PROJECT_DETAILS.location' | translate }}</th>
              <td>{{ this.getFullAddress() }}</td>
            </tr>
            <tr>
              <th>{{ 'PAGE_PROJECT_DETAILS.form.companyName' | translate }}</th>
              <td>{{ projectDetails.company }}</td>
            </tr>
            <tr>
              <th>{{ (isProjectAnalyisProject() ? 'PAGE_PROJECT_DETAILS.responsible' : 'PAGE_PROJECT_DETAILS.tender_manager') | translate }}</th>
              @if (projectDetails.owner) {
                <td>{{ projectDetails.owner | namesFormat }}</td>
              } @else {
                <td class="no-value">nog niet bekend</td>
              }
            </tr>
            @if (projectDetails.riskManager) {
              <tr>
                <th>{{ 'PAGE_PROJECT_DETAILS.project_risk_manager' | translate }}</th>
                <td>{{ projectDetails.riskManager | namesFormat }}</td>
              </tr>
            }
            <tr>
              <th>{{ 'PAGE_PROJECT_DETAILS.form.client' | translate }}</th>
                @if (projectDetails.projectInfo.client) {
                    <td>{{ projectDetails.projectInfo.client }}</td>
                } @else {
                    <td class="no-value">nog niet bekend</td>
                }
            </tr>
            @if (isProjectAnalyisProject()) {
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.developer' | translate }}</th>
                    @if (projectDetails.projectInfo.developer) {
                        <td>{{ projectDetails.projectInfo.developer }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.clientOther' | translate }}</th>
                    @if (projectDetails.projectInfo.clientOther) {
                        <td>{{ projectDetails.projectInfo.clientOther }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
            }
            @if (isLegacyProject()) {
            <tr>
              <th>{{ 'PAGE_PROJECT_DETAILS.form.contractType' | translate }}</th>
              <td>@if (!isEmpty(projectDetails.projectInfo.contractType)) {
                {{ getTranslationWithFallback('PAGE_PROJECT_DETAILS.contractType', projectDetails.projectInfo.contractType) }}
              }</td>
            </tr>
            }
            @if (!isProjectAnalyisProject()) {
              <tr>
                <th>{{ 'PAGE_PROJECT_DETAILS.form.collaboration' | translate }}</th>
                <td>@if (!isEmpty(projectDetails.projectInfo.collaboration)) {
                  {{ getTranslationWithFallback('PAGE_PROJECT_DETAILS.collaboration', projectDetails.projectInfo.collaboration) }}
                }</td>
              </tr>
              @if (!isEmpty(projectDetails.projectInfo.collaborationCompanies)) {
                <tr>
                  <th>{{ 'PAGE_PROJECT_DETAILS.form.collaborationCompanies' | translate }}</th>
                  <td>{{ projectDetails.projectInfo.collaborationCompanies }}</td>
                </tr>
              }
            }

            @if (isProjectAnalyisProject()) {
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.numberOfUnits' | translate }}</th>
                    @if (projectDetails.projectInfo.numberOfUnits) {
                        <td>{{ projectDetails.projectInfo.numberOfUnits }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.commercialSpace' | translate }}</th>
                    @if (projectDetails.projectInfo.commercialSpace) {
                        <td>{{ projectDetails.projectInfo.commercialSpace }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.bvo' | translate }}</th>
                    @if (projectDetails.projectInfo.bvo) {
                        <td>{{ projectDetails.projectInfo.bvo }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.workType' | translate }}</th>
                    @if (workTypes) {
                        <td>{{ workTypes }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.buildingClassification' | translate }}</th>
                    @if (buildingClassifications) {
                        <td>{{ buildingClassifications }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.buildingSubClassification' | translate }}</th>
                    @if (buildingSubClassifications) {
                        <td>{{ buildingSubClassifications }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="grid__col grid__col--5">
        <table class="table-info">
          <tbody>
            @if (isLegacyProject()) {
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.termsAndConditions' | translate }}</th>
                    <td>
                        @if (!isEmpty(projectDetails.projectInfo.termsAndConditions)) {
                            {{ getTranslationWithFallback('PAGE_PROJECT_DETAILS.termsAndConditions', projectDetails.projectInfo.termsAndConditions) }}
                        }
                    </td>
                </tr>
            }
            <tr>
              <th class="table-info__label--wrap">{{ constructionCostsLabel() }}</th>
                @if (constructionCosts) {
                    <td>{{ constructionCosts | priceFormat }}</td>
                } @else {
                    <td class="no-value">nog niet bekend</td>
                }
            </tr>
            @if (isLegacyProject()) {
              <tr>
                <th>{{ 'PAGE_PROJECT_DETAILS.form.profitContribution' | translate }}</th>
                <td>{{ projectDetails.projectInfo.profitContribution | priceFormat }}</td>
              </tr>
            }
            @if (isProjectAnalyisProject()) {
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.tenderCosts' | translate }}</th>
                    @if (tenderCostsLabel()) {
                        <td>{{ tenderCostsLabel() }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.tenderDate' | translate }}</th>
                    @if (projectDetails.projectInfo.tenderDate) {
                        <td>{{ projectDetails.projectInfo.tenderDate }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th class="table-info__label--wrap">{{ 'PAGE_PROJECT_DETAILS.form.designStartsAt' | translate }}</th>
                    @if (projectDetails.projectInfo.designStartsAt) {
                        <td>{{ projectDetails.projectInfo?.designStartsAt | date: ('DATE.short' | translate) }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
            }
            <tr>
              <th>{{ (isProjectAnalyisProject() ? 'PAGE_PROJECT_DETAILS.form.executionStartsAt' : 'PAGE_PROJECT_DETAILS.form.workStartsAt') | translate }}</th>
                @if (projectDetails.projectInfo.workStartsAt) {
                    <td>{{ projectDetails.projectInfo.workStartsAt | date: ('DATE.short' | translate) }}</td>
                } @else {
                    <td class="no-value">nog niet bekend</td>
                }
            </tr>
            <tr>
              <th>{{ (isProjectAnalyisProject() ? 'PAGE_PROJECT_DETAILS.form.finalDeliveryAt' : 'PAGE_PROJECT_DETAILS.form.workEndsAt') | translate }}</th>
                @if (projectDetails.projectInfo.workEndsAt) {
                    <td>{{ projectDetails.projectInfo.workEndsAt| date: ('DATE.short' | translate) }}</td>
                } @else {
                    <td class="no-value">nog niet bekend</td>
                }
            </tr>
            <tr>
              <th>{{ 'PAGE_PROJECT_DETAILS.form.durationInMonths' | translate }}</th>
                @if (projectDetails.projectInfo.durationInMonths) {
                    <td>{{ projectDetails.projectInfo.durationInMonths }}</td>
                } @else {
                    <td class="no-value">nog niet bekend</td>
                }
            </tr>
            @if (isProjectAnalyisProject()) {
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.numberOfPhases' | translate }}</th>
                    @if (projectDetails.projectInfo.numberOfPhases) {
                        <td>{{ projectDetails.projectInfo?.numberOfPhases }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.architect' | translate }}</th>
                    @if (projectDetails.projectInfo.architect) {
                        <td>{{ projectDetails.projectInfo?.architect }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
                <tr>
                    <th>{{ 'PAGE_PROJECT_DETAILS.form.constructor' | translate }}</th>
                    @if (projectDetails.projectInfo.constructor) {
                        <td>{{ projectDetails.projectInfo.constructor }}</td>
                    } @else {
                        <td class="no-value">nog niet bekend</td>
                    }
                </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <app-pdf-page-footer><app-classification></app-classification></app-pdf-page-footer>
</app-pdf-page>
